<template>
  <!-- eslint-disable max-len -->
  <el-dialog
    :title="(item.ID ? '编辑' : '新增') + '站点'"
    :visible="visible"
    @close="onClose"
    @open="onOpen"
    width="50%"
    top="10vh"
    :close-on-click-modal="false"
  >
    <el-form :model="item" ref="itemform" label-width="130px" :rules="rules">
      <el-tabs type="border-card">
        <el-tab-pane label="基本信息">
          <el-form-item label="站点名称" prop="Name">
            <el-input
              v-model.trim="item.Name"
              placeholder="请输入点位名称"
              disabled
            ></el-input>
          </el-form-item>
          <el-form-item label="区域" prop="Area">
            <el-cascader
              style="width: 100%"
              v-model="item.Area"
              :options="areaOptions"
              :props="areaProps"
            ></el-cascader>
          </el-form-item>
          <el-form-item label="详细地址" prop="Address">
            <el-input
              v-model.trim="item.Address"
              placeholder="请输入详细地址"
            ></el-input>
          </el-form-item>
          <el-form-item label="站点类型" prop="StationTypeID">
            <select2
              style="width: 100%"
              v-model="item.StationTypeID"
              url="basic?type=StationType"
              labelName="Name"
              :clearable="false"
              :currentList="currentStationType"
              placeholder="请选择站点类型"
              noDataText="无类型"
              :emptyValue="0"
            ></select2>
          </el-form-item>
          <el-form-item label="业务类型" prop="BusinessTypeID">
            <select2
              style="width: 100%"
              v-model="item.BusinessTypeID"
              url="basic?type=BusinessType"
              labelName="Name"
              :clearable="false"
              :currentList="currentBusinessType"
              placeholder="请选择业务类型"
              noDataText="无类型"
              :emptyValue="0"
            ></select2>
          </el-form-item>
          <el-form-item label="站点状态" prop="StationState">
            <el-select
              v-model="item.StationState"
              placeholder="请选择站点状态"
              style="width: 100%"
            >
              <el-option label="运行" :value="1"></el-option>
              <el-option label="停运" :value="2"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="网络情况" prop="NetWorkType">
             <el-select
              v-model="item.NetWorkType"
              placeholder="请选择网络情况"
              style="width: 100%"
            >
              <el-option label="有线" :value="0"></el-option>
              <el-option label="无线" :value="1"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="入网日期" prop="NetDay">
            <el-date-picker
              v-model="item.NetDay"
              style="width: 100%"
              type="date"
              placeholder="选择日期"
            ></el-date-picker>
          </el-form-item>
          <el-form-item label="SIM号" prop="SIM">
            <el-input
              v-model.trim="item.SIM"
              placeholder="请输入Sim号"
              :disabled="item.NetWorkType === 0"
            ></el-input>
          </el-form-item>
          <el-form-item label="PIN号" prop="PIN">
            <el-input
              v-model.trim="item.PIN"
              placeholder="请输入PIN号"
              :disabled="item.NetWorkType === 0"
            ></el-input>
          </el-form-item>
          <el-form-item label="备注" prop="Remark">
            <el-input
              type="textarea"
              v-model.trim="item.Remark"
              placeholder="请输入备注"
            ></el-input>
          </el-form-item>
        </el-tab-pane>
        <el-tab-pane label="运维信息">
          <el-form-item label="运维单位" prop="Unit">
            <el-input
              v-model.trim="item.Unit"
              placeholder="请输入运维单位"
            ></el-input>
          </el-form-item>
          <el-form-item label="运维人员" prop="Personnel">
            <el-input
              v-model.trim="item.Personnel"
              placeholder="请输入运维人员"
            ></el-input>
          </el-form-item>
          <el-form-item label="联系电话" prop="Phone">
            <el-input
              v-model.trim="item.Phone"
              placeholder="请输入联系人员"
            ></el-input>
          </el-form-item>
          <el-form-item label="TV ID" prop="TVID">
            <el-input
              v-model.trim="item.TVID"
              placeholder="请输入TV ID"
            ></el-input>
          </el-form-item>
          <el-form-item label="TV密码" prop="TVPWD">
            <el-input
              v-model.trim="item.TVPWD"
              placeholder="请输入TV密码"
            ></el-input>
          </el-form-item>
        </el-tab-pane>
        <el-tab-pane label="软硬件信息" v-if="!item.ID">
          <el-form-item label="授权码" prop="AuthCode">
            <el-input
              v-model.trim="item.AuthCode"
              placeholder="请输入授权码"
            ></el-input>
          </el-form-item>
          <el-form-item label="机器码" prop="MachineCode">
            <el-input
              v-model.trim="item.MachineCode"
              placeholder="请输入机器码"
            ></el-input>
          </el-form-item>
          <el-form-item label="当前版本" prop="CurrentVersion">
            <el-input
              v-model.trim="item.CurrentVersion"
              placeholder="请输入当前版本"
            ></el-input>
          </el-form-item>
          <el-form-item label="工控机品牌" prop="Brand">
            <el-input
              v-model.trim="item.IpcDevice.Brand"
              placeholder="请输入工控机品牌"
            ></el-input>
          </el-form-item>
          <el-form-item label="工控机型号" prop="ModelNumber">
            <el-input
              v-model.trim="item.IpcDevice.ModelNumber"
              placeholder="请输入工控机型号"
            ></el-input>
          </el-form-item>
          <el-form-item label="CPU" prop="CPU">
            <el-input
              v-model.trim="item.IpcDevice.CPU"
              placeholder="请输入CPU"
            ></el-input>
          </el-form-item>
          <el-form-item label="内存" prop="Memory">
            <el-input
              v-model.trim="item.IpcDevice.Memory"
              placeholder="请输入内存"
            ></el-input>
          </el-form-item>
          <el-form-item label="操作系统版本" prop="OSVer">
            <el-input
              v-model.trim="item.IpcDevice.OSVer"
              placeholder="请输入操作系统版本"
            ></el-input>
          </el-form-item>
          <el-form-item label="操作系统安装日期" prop="OSSetupDt">
            <el-date-picker
              v-model="item.IpcDevice.OSSetupDt"
              style="width: 100%"
              type="date"
              placeholder="选择日期"
            ></el-date-picker>
          </el-form-item>
        </el-tab-pane>
      </el-tabs>
    </el-form>
    <div slot="footer">
      <el-button @click="onClose">
        <i class="fas fa-times"></i> 取 消
      </el-button>
      <el-button type="primary" @click="onSubmit" :disabled="submitting">
        <i class="far fa-save"></i> 确 定
      </el-button>
    </div>
  </el-dialog>
</template>

<script>
export default {
  props: {
    value: Object,
    visible: Boolean,
  },
  data() {
    const checkArea = (rule, value, callback) => {
      if (this.item.ProvinceCodeID) {
        return callback();
      }
      return callback(new Error("区域不能为空"));
    };
    return {
      areaProps: {
        value: "CodeID",
        label: "Name",
        children: "Children",
        checkStrictly: true,
      },
      areaOptions: [],
      item: _.clone(this.value),
      rules: {
        Name: [
          { required: true, message: "点位名称不能为空", trigger: "blur" },
        ],
        StationTypeID: [
          { required: true, message: "站点类型不能为空", trigger: "blur" },
        ],
        BusinessTypeID: [
          { required: true, message: "业务类型不能为空", trigger: "blur" },
        ],
        NetWorkType: [
          { required: true, message: "网络情况不能为空", trigger: "blur" },
        ],
        Area: [
          { required: true, message: "区域不能为空", trigger: "blur" },
          { validator: checkArea, trigger: "blur" },
        ],
        AuthCode: [
          { required: true, message: "授权码不能为空", trigger: "blur" },
        ],
        MachineCode: [
          { required: true, message: "机器码不能为空", trigger: "blur" },
        ],
        NetDay: [
          { required: true, message: "入网日期不能为空", trigger: "blur" },
        ],
      },
      submitting: false,
      currentStationType: [],
      currentBusinessType: [],
    };
  },
  computed: {
    token() {
      return this.$store.state.auth.token;
    },
  },
  watch: {
    "item.NetWorkType": {
      handler() {
        this.item.SIM = "";
        this.item.PIN = "";
      },
    },
  },
  created() {},
  methods: {
    onOpen() {
      this.choseArea();
      this.item = _.clone(this.value);
      if (this.value.ID) {
        this.currentStationType = [
          { ID: this.value.StationTypeID, Name: this.value.StationType.Name },
        ];
        this.currentBusinessType = [
          { ID: this.value.BusinessTypeID, Name: this.value.BusinessType.Name },
        ];
      }
      this.item.Area = [];
      if (this.item.Province) this.item.Area[0] = this.item.ProvinceCodeID;
      if (this.item.City) this.item.Area[1] = this.item.CityCodeID;
      if (this.item.County) this.item.Area[2] = this.item.CountyCodeID;
    },
    onClose() {
      this.$emit("update:visible", false);
      this.$emit("cancel");
      this.$refs.itemform.resetFields();
    },
    onSubmit() {
      if (this.item.Area[0]) this.item.ProvinceCodeID = this.item.Area[0];
      else this.item.ProvinceCodeID = "";
      if (this.item.Area[1]) this.item.CityCodeID = this.item.Area[1];
      else this.item.CityCodeID = "";
      if (this.item.Area[2]) this.item.CountyCodeID = this.item.Area[2];
      else this.item.CountyCodeID = "";
      this.$refs.itemform.validate((valid) => {
        if (!valid) {
          return;
        }
        this.submitting = true;
        this.$emit("input", this.item);
        const itemData = { ...this.item };
        // 保存的操作
        this.$axios
          .request({
            url: this.item.ID ? `station/${itemData.ID}` : "station",
            method: itemData.ID ? "put" : "post",
            data: itemData,
          })
          .then(() => {
            this.$message.success(itemData.ID ? "编辑成功" : "新增成功");
            this.submitting = false;
            this.$emit(itemData.ID ? "form:updated" : "form:created", true);
            this.$emit("form:saved", true);
            this.$emit("update:visible", false);
          })
          .catch(({ response }) => {
            this.$sys.alarmResponse(response);
            this.submitting = false;
            this.$emit(itemData.ID ? "form:updated" : "form:created", false);
            this.$emit("form:saved", false);
          });
      });
    },
    choseArea() {
      this.$axios
        .get("area")
        .then((response) => {
          this.areaOptions = response.data.data;
        })
        .catch(({ response }) => {
          this.$sys.alarmResponse(response);
        })
        .finally(() => {});
    },
  },
};
</script>
